module.exports = __webpack_public_path__ + "img/democratic-republic-of-the-congo.f1294c14.png";